export * from './azure-active-directory-synchronisiert.interface';
